import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavService } from 'src/app/services/nav.service';
import { SettingsService } from 'src/app/services/settings.service';
// import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from '@angular/material';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 800,
  hideDelay: 100,
  touchendHideDelay: 1000,
  position: 'right'
};
@Component({
  standalone: false,
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  providers: [
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults}
]
})
export class VerticalMenuComponent implements OnInit, OnDestroy {
  currentSelection = '';
  private unsubscribe$: Subject<boolean> = new Subject();
  constructor(private navService: NavService, private settingsService: SettingsService) { }
  @Output() panelTitle: EventEmitter<any> = new EventEmitter();
  darkModeEnabled = false;

  ngOnInit(): void {
    this.subscribeToPanelChange();
    this.subscribeToDarkMode();
  }

  subscribeToPanelChange(): void{
    this.navService.getPanelObs().pipe(takeUntil(this.unsubscribe$)).subscribe((panel) => {
      this.navButtonClicked(panel);
    });
  }

  subscribeToDarkMode(){
    this.settingsService.getDarkModeEnabled().pipe(takeUntil(this.unsubscribe$)).subscribe((val: boolean) => {
      if(val !== null && val !== undefined){
         this.darkModeEnabled = val;
      }
    });
  }

  navButtonClicked(panel: string): void{
    panel = this.currentSelection === panel ? 'hide' : panel;
    this.currentSelection = panel;
    this.panelTitle.emit(panel);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
